import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { NotableLabel } from '../../utils/notableLabels';

interface NotableLabelsBadgeProps {
  count: number;
  labels: NotableLabel[];
}

export const NotableLabelsBadge = ({ count, labels }: NotableLabelsBadgeProps) => {
  if (count === 0) return null;

  const tooltip = (
    <Tooltip id="notable-labels-tooltip">
      <div className="text-start">
        <strong>Notable findings:</strong>
        <ul className="mb-0 ps-3">
          {labels.map(({ label, value }) => (
            <li key={label}>{label}: {value}</li>
          ))}
        </ul>
      </div>
    </Tooltip>
  );

  return (
    <OverlayTrigger placement="top" overlay={tooltip}>
      <Badge
        bg="warning"
        text="dark"
        className="ms-2"
        style={{ cursor: 'pointer' }}
      >
        {count} notable
      </Badge>
    </OverlayTrigger>
  );
};
